import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '@context/presentation';
import { HighlightSection, ScriptHeader } from './styles';
import { Line } from '@slides/styles';

export const IntroScript = () => {
    const { t } = useTranslation();
    const { firstName, lastName } = useClient();

    return (
        <>
            <ScriptHeader>
                {t('introduction.script.title')}
            </ScriptHeader>
            <Line />
            <div>
                {t('introduction.script.1')}
                <strong>{`${firstName} ${lastName}`}</strong>
                {t('introduction.script.2')}
                <strong>{`${firstName} ${lastName}`}</strong>
                {t('introduction.script.3')}
            </div>
            <HighlightSection>
                <strong>{t('introduction.script.4')}</strong>
            </HighlightSection>
            <div>
                <strong>{t('introduction.script.5')}</strong>
            </div>
        </>
    );
};

export default IntroScript;